import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AgentSettings } from '../settings/agent.settings';
import { HttpCssClient } from '../shared/http-request.interceptor'


@Injectable()
export class AgentService{
    constructor(private http:HttpCssClient){}

    agentLogin(sysuser):Observable<Object>{
        let url = AgentSettings.AGENT_LOGIN;
        return this.http.post(url,sysuser)
         .pipe(map((response: Response)=>{
            let token = response.headers.get("authorization");
            let body = response;
            if(token != null){
                this.http.addHeader("Authorization",token);
            }else{
                this.http.removeHeader("Authorization");
            }

            return {response: body, token: token };
        }));
    }
}